<template>
    <div class="user-center-page">
        <!-- 公共头部 -->
        <HeaderPc />

        <!-- 个人中心主体（布局修复核心） -->
        <div class="user-center-main">
            <el-container class="container">
                <!-- 侧边导航（固定宽度+布局优化） -->
                <el-aside class="sidebar">
                    <!-- 个人信息卡片 -->
                    <div class="user-info-card">
                        <div class="avatar-wrap">
                            <img :src="userInfo.originalAvatar ? resourceUrl + userInfo.originalAvatar : ''" alt="头像" class="user-avatar" @error="handleAvatarError">
                            <div class="avatar-mask" @click="editAvatar">
                                <i class="el-icon-camera"></i>
                            </div>
                        </div>
                        <div class="user-base-info">
                            <h3 class="username">{{ userInfo.nickname }}</h3>
                            <p class="user-role" :class="userInfo.group_id == 2 ? 'teacher-role' : 'student-role'">
                                <i :class="userInfo.group_id == 2 ? 'el-icon-trophy' : 'el-icon-user'"></i>
                                {{ userInfo.group_id == 2 ? '认证教师' : '普通学员' }}
                            </p>
                        </div>
                        <div class="user-stats">
                            <div class="stats-item">
                                <span class="stats-num">{{ userInfo.coll_count || 0 }}</span>
                                <span class="stats-text">收藏课程</span>
                            </div>
                            <div class="stats-item">
                                <span class="stats-num">{{ userInfo.buy_count || 0 }}</span>
                                <span class="stats-text">已购课程</span>
                            </div>
                            <div class="stats-item" v-if="userInfo.group_id == 2">
                                <span class="stats-num">{{ userInfo.send_count || 0 }}</span>
                                <span class="stats-text">发布课程</span>
                            </div>
                        </div>
                    </div>

                    <div class="sidebar-nav">
                        <div 
                            class="nav-item"
                            v-for="item in navList"
                            :key="item.key"
                            :class="{ active: activeNav === item.key }"
                            @click="switchNav(item.key)"
                        >
                            <i :class="item.icon"></i>
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                </el-aside>

                <el-container class="main-content">
                    <div class="content-panel" v-if="activeNav === 'profile'">
                        <div class="panel-header">
                            <h2 class="panel-title">
                                <i class="el-icon-user"></i>
                                个人信息
                            </h2>
                            <el-button type="primary" size="mini" @click="toggleEditProfile">
                                {{ isEditProfile ? '取消' : '编辑信息' }}
                            </el-button>
                        </div>
                        <div class="profile-form">
                            <el-form :model="userForm" label-width="100px" :disabled="!isEditProfile" size="medium">
                                <el-row :gutter="30">
                                    <el-col :span="12">
                                        <el-form-item label="用户名" prop="username">
                                            <el-input v-model="userForm.username" placeholder="请输入用户名"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="昵称" prop="nickname">
                                            <el-input v-model="userForm.nickname" placeholder="请输入昵称"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="手机号" prop="mobile">
                                            <el-input v-model="userForm.mobile" placeholder="请输入手机号" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="邮箱" prop="email">
                                            <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="性别" prop="gender">
                                            <el-select v-model="userForm.gender" placeholder="请选择性别">
                                                <el-option label="男" :value="1"></el-option>
                                                <el-option label="女" :value="2"></el-option>
                                                <el-option label="保密" :value="0"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="生日" prop="birthday">
                                            <el-date-picker v-model="userForm.birthday" type="date" placeholder="请选择生日" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="个人简介" prop="motto">
                                            <el-input v-model="userForm.motto" type="textarea" :rows="4" placeholder="请输入个人简介"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item v-if="isEditProfile" style="margin-top: 20px;">
                                    <el-button type="primary" @click="saveProfile">保存修改</el-button>
                                    <el-button @click="toggleEditProfile">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <!-- 2. 我的课程（布局修复） -->
                    <div class="content-panel" v-if="activeNav === 'courses'">
                        <div class="panel-header">
                            <h2 class="panel-title">
                                <i class="el-icon-folder-opened"></i>
                                我的课程
                            </h2>
                            <div class="course-tabs">
                                <el-radio-group v-model="courseTab" size="mini" @input="handlePageChange(1)">
                                    <el-radio label="paid">已付费课程</el-radio>
                                    <el-radio label="coll">我的收藏</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                        <!-- 课程列表（布局修复：卡片间距+响应式） -->
                        <div class="course-list" v-if="courseList.length > 0">
                            <div class="course-item" v-for="course in courseList" :key="course.id">
                                <div class="course-cover">
                                    <img :src="getImageUrl(course.cover)" alt="课程封面" @error="handleCourseCoverError($event)">
                                    <div class="learn-progress" v-if="course.learnProgress > 0">
                                        <span>{{ course.learnProgress }}%</span>
                                        <div class="progress-bar">
                                            <div class="progress-fill" :style="{ width: course.learnProgress + '%' }"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="course-info">
                                    <h3 class="course-title" @click="goCourseDetail(course.id)">{{ course.title }}</h3>
                                    <p class="course-teacher">
                                        {{ course.name || '' }}
                                    </p>
                                    <p class="course-teacher">
                                        <i class="el-icon-user-solid"></i>
                                        讲师：{{ course.author_name || '-' }}
                                    </p>
                                    <div class="course-meta">
                                        <span class="meta-item" :class="course.type === 'free' ? 'free-tag' : 'pay-tag'">
                                            <i :class="course.type === 'free' ? 'el-icon-free' : 'el-icon-money'"></i>
                                            {{ course.is_free == 1 ? '免费课程' : '付费课程' }}
                                        </span>
                                        <span class="meta-item">
                                            <i class="el-icon-video-play"></i>
                                            总章节：{{ course.chapter_count || 0 }}章
                                        </span>
                                        <span class="meta-item" v-if="courseTab == 'paid' && course.pay_time">
                                            <i class="el-icon-time"></i>
                                            购买时间：{{ course.pay_time }}
                                        </span>
                                        <span class="meta-item order-no-item" v-if="courseTab == 'paid' && course.order_no">
                                            <i class="el-icon-document"></i>
                                            订单号：{{ course.order_no }}
                                            <i class="el-icon-copy-document copy-icon" @click.stop="copyOrderNo(course.order_no)" title="复制"></i>
                                        </span>
                                        <el-tag v-if="courseTab == 'paid' && course.order_status" :type="course.order_status == 1 ? 'success' : (course.order_status == 2 ? 'danger' : 'warning')" size="mini">
                                            {{ course.order_status == 1 ? '已支付' : (course.order_status == 2 ? '已退款' : '待支付') }}
                                        </el-tag>
                                    </div>
                                </div>
                                <div class="course-actions">
                                    <el-button type="primary" size="mini" @click="goCourseDetail(course.id)" :disabled="courseTab == 'paid' && (course.status != 'succ' || course.refund_sh != 0)">
                                        <i class="el-icon-video-play"></i>
                                        继续学习
                                    </el-button>
                                    <el-button type="warning" size="mini" @click="applyRefund(course)" v-if="courseTab == 'paid' && course.status == 'succ'" :disabled="courseTab == 'paid' && (course.refund_sh == '1' || course.refund_sh == '2')">
                                        <i class="el-icon-refresh-left"></i>
                                        {{ course.refund_sh == 1 ? '退款申请中' : '申请退款' }}
                                    </el-button>
                                    <el-button type="text" size="mini" @click="removeCourse(course.id)" v-if="courseTab == 'coll'">
                                        <i class="el-icon-delete"></i>
                                        移出
                                    </el-button>
                                </div>
                            </div>
                        </div>

                        <!-- 空状态 -->
                        <div class="empty-state" v-else>
                            <i class="el-icon-s-data"></i>
                            <p>暂无相关课程</p>
                            <el-button type="primary" @click="goCourseList">去选课</el-button>
                        </div>

                        <!-- 分页 -->
                        <div class="pagination-wrap" v-if="courseTotal > 0" style="margin-top: 20px; text-align: center;">
                            <el-pagination
                                @current-change="handlePageChange"
                                :current-page="coursePage"
                                :page-size="coursePageSize"
                                layout="total, prev, pager, next"
                                :total="courseTotal">
                            </el-pagination>
                        </div>
                    </div>

                    <!-- 4. 账户安全（布局修复） -->
                    <div class="content-panel" v-if="activeNav === 'security'">
                        <div class="panel-header">
                            <h2 class="panel-title">
                                <i class="el-icon-lock"></i>
                                账户安全
                            </h2>
                        </div>

                        <div class="security-list">
                            <div class="security-item" v-for="(item, index) in securityList" :key="index">
                                <div class="item-left">
                                    <i :class="item.icon"></i>
                                    <div class="item-info">
                                        <h4>{{ item.title }}</h4>
                                        <p>{{ item.desc }} {{ lastLoginTime || '-' }}</p>
                                    </div>
                                </div>
                                <el-button type="text" @click="item.handleClick">
                                    {{ item.btnText }}
                                </el-button>
                            </div>
                        </div>
                    </div>

                    <!-- 5. 钱包模块（新增） -->
                    <div class="content-panel" v-if="activeNav === 'wallet'">
                        <div class="panel-header">
                            <h2 class="panel-title">
                                <i class="el-icon-wallet"></i>
                                我的钱包
                            </h2>
                        </div>

                        <!-- 钱包余额卡片 -->
                        <div class="wallet-balance-card">
                            <div class="balance-info">
                                <div class="balance-item">
                                    <p class="balance-label">账户余额（元）</p>
                                    <h2 class="balance-amount">¥{{ walletInfo.balance || '0.00' }}</h2>
                                </div>
                                <div class="balance-item freeze-item">
                                    <p class="balance-label">申请中金额（元）</p>
                                    <h3 class="freeze-amount">¥{{ walletInfo.freezeBalance || '0.00' }}</h3>
                                </div>
                            </div>
                            <div class="balance-actions">
                                <el-button type="warning" size="medium" icon="el-icon-bank-card" @click="openWithdrawDialog">申请提现</el-button>
                            </div>
                        </div>

                        <!-- 账单明细 -->
                        <div class="bill-list-wrap" style="margin-top: 24px;">
                            <div class="bill-header">
                                <h3 class="bill-title">账单明细</h3>
                                <el-select v-model="billType" size="mini" style="width: 120px;" @change="handleBillPageChange(1)">
                                    <el-option label="全部账单" :value="0"></el-option>
                                    <el-option label="收入" :value="1"></el-option>
                                    <el-option label="支出" :value="2"></el-option>
                                </el-select>
                            </div>

                            <div class="bill-list" v-if="filterBillList.length > 0">
                                <el-table :data="filterBillList" border size="medium" style="width: 100%;">
                                    <el-table-column prop="id" label="账单编号" width="100"></el-table-column>
                                    <el-table-column prop="type" label="账单类型" width="120">
                                        <template slot-scope="scope">
                                            <el-tag :type="scope.row.tagType">{{ scope.row.typeText }}</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="amount" label="金额（元）" width="120">
                                        <template slot-scope="scope">
                                            <span :class="scope.row.type == 1 ? 'text-green' : 'text-red'">
                                                {{ scope.row.type == 1 ? '+' : '-' }}{{ scope.row.amount || '0' }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="status" label="状态" width="120">
                                        <template slot-scope="scope">
                                            <el-tag :type="scope.row.status === 'success' ? 'success' : 'warning'">
                                                {{ scope.row.statusText }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
                                    <el-table-column prop="remark" label="备注"></el-table-column>
                                </el-table>
                            </div>

                            <div class="empty-state" v-else>
                                <i class="el-icon-s-data"></i>
                                <p>暂无账单记录</p>
                            </div>

                            <!-- 账单分页 -->
                            <div class="pagination-wrap" v-if="billTotal > 0" style="margin-top: 20px; text-align: center;">
                                <el-pagination
                                    @current-change="handleBillPageChange"
                                    :current-page="billPage"
                                    :page-size="billPageSize"
                                    layout="total, prev, pager, next"
                                    :total="billTotal">
                                </el-pagination>
                            </div>
                        </div>
                    </div>

                    <!-- 6. 教师入驻模块（新增：多状态） -->
                    <div class="content-panel" v-if="activeNav === 'teacher'">
                        <!-- 状态1：未入驻 - 填写申请表单 -->
                        <div class="teacher-apply-form" v-if="teacherStatus == 'none'">
                            <div class="panel-header">
                                <h2 class="panel-title">
                                    <i class="el-icon-trophy"></i>
                                    教师入驻申请
                                </h2>
                                <p class="apply-tip">
                                    <i class="el-icon-info"></i>
                                    填写真实信息，审核通过后即可发布课程
                                </p>
                            </div>

                            <el-form :model="teacherApplyForm" label-width="120px" size="medium" ref="teacherForm" :rules="teacherFormRules">
                                <el-row :gutter="30">
                                    <el-col :span="12">
                                        <el-form-item label="真实姓名" prop="realName">
                                            <el-input v-model="teacherApplyForm.realName" placeholder="请输入真实姓名"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="手机号" prop="phone">
                                            <el-input v-model="teacherApplyForm.phone" placeholder="请输入手机号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="身份证号" prop="idCard">
                                            <el-input v-model="teacherApplyForm.idCard" placeholder="请输入身份证号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="教学方向" prop="subject">
                                            <el-select v-model="teacherApplyForm.subject" placeholder="请选择教学方向" multiple filterable style="width: 100%;">
                                                <el-option v-for="(item, index) in servers" :key="index" :label="item" :value="index"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="个人简介" prop="motto">
                                            <el-input v-model="teacherApplyForm.motto" type="textarea" :rows="4" placeholder="请介绍你的教学经验、擅长领域等"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="资质证明" prop="certificate">
                                            <el-upload
                                                action="#"
                                                list-type="picture-card"
                                                :http-request="uploadCertificateFile"
                                                :on-success="handleCertUploadSuccess"
                                                :file-list="certFileList"
                                                :limit="3"
                                                accept=".jpg,.png,.pdf"
                                            >
                                                <i class="el-icon-plus"></i>
                                            </el-upload>
                                            <div class="el-upload__text">点击上传资质证明<br/>(身份证/学历/职业证书等)</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item style="margin-top: 20px;">
                                    <el-button type="primary" @click="submitTeacherApply">提交申请</el-button>
                                    <el-button @click="resetTeacherForm">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- 状态2：审核中 -->
                        <div class="teacher-audit-ing" v-if="teacherStatus == 'auditing'">
                            <div class="audit-card">
                                <div class="audit-icon">
                                    <i class="el-icon-loading"></i>
                                </div>
                                <h3 class="audit-title">申请已提交，审核中</h3>
                                <p class="audit-desc">
                                    你的教师入驻申请已提交，审核人员将在1-3个工作日内完成审核，请耐心等待
                                </p>
                                <div class="audit-info">
                                    <p>提交时间：{{ teacherAuditInfo.submitTime || '' }}</p>
                                    <p>预计完成时间：{{ teacherAuditInfo.expectTime || '' }}</p>
                                </div>
                                <el-button type="text" @click="checkAuditStatus">刷新审核状态</el-button>
                            </div>
                        </div>

                        <!-- 状态3：审核驳回 -->
                        <div class="teacher-audit-reject" v-if="teacherStatus == 'reject'">
                            <div class="reject-card">
                                <div class="reject-icon">
                                    <i class="el-icon-circle-close"></i>
                                </div>
                                <h3 class="reject-title">申请已驳回</h3>
                                <div class="reject-reason">
                                    <p class="reason-label">驳回原因：</p>
                                    <p class="reason-content">{{ teacherAuditInfo.rejectReason }}</p>
                                </div>
                                <el-button type="primary" @click="reSubmitTeacherApply">重新提交申请</el-button>
                            </div>
                        </div>

                        <!-- 状态4：审核通过 - 课程发布+已上传列表 -->
                        <div class="teacher-passed" v-if="teacherStatus === 'passed'">
                            <!-- 发布课程按钮 -->
                            <div class="panel-header">
                                <h2 class="panel-title">
                                    <i class="el-icon-trophy"></i>
                                    教师中心
                                </h2>
                                <el-button type="primary" size="mini" @click="openPublishDialog" v-if="teacherAuditInfo.substatus">
                                    <i class="el-icon-plus"></i>
                                    发布新课程
                                </el-button>
                            </div>

                            <!-- 课程发布弹窗 -->
                            <el-dialog title="发布新课程" :visible.sync="showPublishCourseDialog" width="800px" center>
                                <div v-if="coursePublishTip" class="publish-tip" v-html="coursePublishTip"></div>
                                <el-form :model="publishCourseForm" label-width="100px" size="medium">
                                    <el-row :gutter="30">
                                        <el-col :span="12">
                                            <el-form-item label="课程标题">
                                                <el-input v-model="publishCourseForm.name" placeholder="请输入课程标题"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="课程分类">
                                                <el-cascader
                                                    v-model="publishCourseForm.category"
                                                    :options="categoryOptions"
                                                    :props="{ value: 'id', label: 'name', children: 'children' }"
                                                    placeholder="请选择课程分类"
                                                    filterable
                                                    clearable
                                                ></el-cascader>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="课程类型">
                                                <el-radio-group v-model="publishCourseForm.ctype">
                                                    <el-radio label="1">视频课程</el-radio>
                                                    <el-radio label="2">文件课程</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="是否免费">
                                                <el-radio-group v-model="publishCourseForm.is_free">
                                                    <el-radio label="1">免费</el-radio>
                                                    <el-radio label="2">付费</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="课程封面">
                                                <div class="cover-upload-wrap" @click="editCourseCover">
                                                    <img v-if="publishCourseForm.cover" :src="getImageUrl(publishCourseForm.cover)" alt="课程封面" class="cover-preview">
                                                    <div v-else class="cover-placeholder">
                                                        <i class="el-icon-plus"></i>
                                                        <p>点击上传封面</p>
                                                    </div>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" v-if="publishCourseForm.is_free == 2">
                                            <el-form-item label="课程价格">
                                                <el-input v-model="publishCourseForm.price" placeholder="请输入课程价格" suffix="元"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="课程简介">
                                                <el-input v-model="publishCourseForm.desc" placeholder="请输入课程简介"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="课程描述">
                                                <el-input v-model="publishCourseForm.describe" type="textarea" :rows="4" placeholder="请输入课程描述"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                                <template v-slot:footer>
                                    <el-button @click="showPublishCourseDialog = false">取消</el-button>
                                    <el-button type="primary" @click="publishCourse">保存课程</el-button>
                                </template>
                            </el-dialog>

                            <!-- 已发布课程列表 -->
                            <div class="published-course-list" style="margin-top: 24px;" v-loading="publishedCourseLoading">
                                <div class="course-card-list" v-if="publishedCourseList.length > 0">
                                    <div class="course-card" v-for="course in publishedCourseList" :key="course.id">
                                        <div class="card-header">
                                            <img :src="course.cover ?  resourceUrl + course.cover : ''" alt="课程封面" class="course-cover" @error="handleCourseCoverError($event)">
                                            <div class="course-tag" :class="course.is_free == 1 ? 'free-tag' : 'pay-tag'">
                                                <i :class="course.is_free == 1 ? 'el-icon-free' : 'el-icon-money'"></i>
                                                {{ course.is_free == 1 ? '免费课程' : '付费课程' }}
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <h3 class="course-title">{{ course.name }}</h3>
                                            <div class="course-status">
                                                <el-tag :type="course.is_sh == 0 ? 'warning' : (course.is_sh == 1 ? 'success' : 'danger')" size="mini">
                                                    {{ course.is_sh == 0 ? '审核中' : (course.is_sh == 1 ? '已通过' : '已驳回') }}
                                                </el-tag>
                                            </div>
                                            <div class="course-meta">
                                                <span><i class="el-icon-document"></i> {{ course.chapter_count || 0 }}章节</span>
                                                <span><i class="el-icon-user"></i> {{ course.looks || 0 }}人</span>
                                                <span v-if="course.is_free == 2"><i class="el-icon-money"></i> ￥{{ course.origin_price || 0 }}</span>
                                            </div>
                                        </div>
                                        <div class="card-actions">
                                            <el-button type="primary" size="mini" @click="manageChapter(course)">章节管理</el-button>
                                            <el-button type="success" size="mini" @click="editCourse(course)" :disabled="course.is_sh == 1">编辑</el-button>
                                            <el-button type="danger" size="mini" @click="deleteCourse(course)" :disabled="course.is_sh == 1">删除</el-button>
                                        </div>
                                    </div>
                                </div>

                                <div class="empty-state" v-else>
                                    <i class="el-icon-s-data"></i>
                                    <p>暂无已发布课程</p>
                                    <el-button type="primary" @click="openPublishDialog" v-if="teacherAuditInfo.substatus">发布第一个课程</el-button>
                                </div>

                                <!-- 分页 -->
                                <div class="pagination-wrap" v-if="publishedCourseTotal > 0" style="margin-top: 20px; text-align: center;">
                                    <el-pagination
                                        @current-change="handlePublishedPageChange"
                                        :current-page="publishedCoursePage"
                                        :page-size="publishedCoursePageSize"
                                        layout="total, prev, pager, next"
                                        :total="publishedCourseTotal">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-container>
            </el-container>
        </div>

        <!-- 公共底部 -->
        <FooterPc />

        <!-- 修改密码弹窗 -->
        <el-dialog title="修改密码" :visible.sync="showPasswordDialog" width="500px" :close-on-click-modal="false" center @close="resetPasswordForm">
            <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px" size="medium">
                <el-form-item label="手机号">
                    <el-input :value="userInfo.mobile" disabled></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="code">
                    <el-input v-model="passwordForm.code" placeholder="请输入验证码">
                        <el-button slot="append" @click="sendVerifyCode" :disabled="codeCountdown > 0">
                            {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码（6位以上）" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showPasswordDialog = false">取消</el-button>
                <el-button type="primary" @click="submitPasswordChange">确定</el-button>
            </div>
        </el-dialog>

        <!-- 提现弹窗 -->
        <el-dialog title="提现申请" :visible.sync="showWithdrawDialog" width="500px" center>
            <el-form :model="withdrawForm" label-width="100px" size="medium">
                <el-form-item label="提现金额">
                    <el-input v-model="withdrawForm.amount" type="number" placeholder="请输入提现金额">
                        <template slot="append">元</template>
                    </el-input>
                    <div class="withdraw-tip">当前余额：¥{{ walletInfo.balance || '0.00' }}</div>
                </el-form-item>
                <el-form-item label="收款账号">
                    <el-input v-model="withdrawForm.account" placeholder="请输入支付宝/微信/银行卡账号"></el-input>
                </el-form-item>
                <el-form-item label="收款人">
                    <el-input v-model="withdrawForm.name" placeholder="请输入收款人姓名"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showWithdrawDialog = false">取消</el-button>
                <el-button type="primary" @click="submitWithdraw">提交申请</el-button>
            </div>
        </el-dialog>

        <!-- 章节管理弹窗 -->
        <el-dialog :title="(currentCourse && '【' + currentCourse.name + '】') + '章节管理'" :visible.sync="showChapterDialog" width="900px" center @close="resetChapterForm"> 
            <div class="chapter-header" v-if="currentCourse && currentCourse.is_sh != 1">
                <el-button type="primary" size="small" @click="addChapter">
                    <i class="el-icon-plus"></i> 添加章节
                </el-button>
            </div>
            <el-table :data="chapterList" style="width: 100%; margin-top: 16px;">
                <el-table-column prop="name" label="章节标题" align="center"></el-table-column>
                <el-table-column label="内容" align="center">
                    <template slot-scope="scope">
                        <span v-if="currentCourse && currentCourse.ctype == 1">
                            <i class="el-icon-video-camera"></i> 视频
                        </span>
                        <span v-else-if="currentCourse && currentCourse.ctype == 2">
                            <i class="el-icon-document"></i> 文件
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="duration" label="时长(秒)" width="100" v-if="currentCourse && currentCourse.ctype == 1" align="center"></el-table-column>
                <el-table-column prop="listorder" label="排序" width="80" align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="editChapter(scope.row)" :disabled="currentCourse.is_sh == 1">编辑</el-button>
                        <el-button type="text" size="small" @click="deleteChapter(scope.row)" :disabled="currentCourse.is_sh == 1">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap" v-if="chapterTotal > 0" style="margin-top: 20px; text-align: center;">
                <el-pagination
                    @current-change="handleChapterPageChange"
                    :current-page="chapterPage"
                    :page-size="chapterPageSize"
                    layout="total, prev, pager, next"
                    :total="chapterTotal">
                </el-pagination>
            </div>
        </el-dialog>

        <!-- 章节编辑弹窗 -->
        <el-dialog :title="chapterForm.id ? '编辑章节' : '添加章节'" :visible.sync="showChapterFormDialog" width="600px" center>
            <el-form :model="chapterForm" label-width="100px">
                <el-form-item label="章节标题">
                    <el-input v-model="chapterForm.title" placeholder="请输入章节标题"></el-input>
                </el-form-item>
                
                <!-- 视频课程字段 -->
                <template v-if="currentCourse && currentCourse.ctype == 1">
                    <el-form-item label="视频上传">
                        <div class="video-upload-wrap" @click="uploadChapterVideo">
                            <div v-if="chapterForm.video" class="video-info">
                                <i class="el-icon-video-camera"></i>
                                <span>已上传视频</span>
                            </div>
                            <div v-else class="upload-placeholder">
                                <i class="el-icon-upload"></i>
                                <p>点击上传视频</p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="视频时长">
                        <el-input v-model="chapterForm.duration" placeholder="请输入时长（秒）" type="number"></el-input>
                        <span>单位: 秒</span>
                    </el-form-item>
                </template>
                
                <!-- 文件课程字段 -->
                <template v-if="currentCourse && currentCourse.ctype == 2">
                    <el-form-item label="文件上传">
                        <div class="file-upload-wrap" @click="uploadChapterFile">
                            <div v-if="chapterForm.file" class="file-info">
                                <i class="el-icon-document"></i>
                                <span>已上传文件</span>
                            </div>
                            <div v-else class="upload-placeholder">
                                <i class="el-icon-upload"></i>
                                <p>点击上传文件</p>
                            </div>
                        </div>
                    </el-form-item>
                </template>
                
                <el-form-item label="排序">
                    <el-input-number v-model="chapterForm.sort" :min="0" placeholder="请输入排序"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="showChapterFormDialog = false">取消</el-button>
                <el-button type="primary" @click="saveChapter">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import HeaderPc from '@/components/pc/header.vue';
import FooterPc from '@/components/pc/fotter.vue';
import { getUserInfo, updateAvatar, updateUserInfo, updatePassword, sendSmsCode, getWalletInfo, getTransactionList, applyWithdraw, teacherApply, publishCourse, publishCourseChapter, getMyCourseList, getChapterList, deleteCourse, deleteCourseChapter  } from '@/api/user'
import { getUserCourseList, dolCollect, getConfigs, getCategory, applyRefund } from '@/api/home'
import { uploadAvatar, uploadCertificate, uploadCourseMaterial } from '@/utils/upload'
import { Session } from '@/utils/storage';
import { getCoursePublishTip } from '@/api/system';

export default {
    name: 'UserCenter',
    components: {
        HeaderPc,
        FooterPc
    },
    data() {
        return {
            input: '',
            // 激活的导航项
            activeNav: 'profile',
            // 系统资源地址
            resourceUrl: process.env.VUE_APP_STATIC_URL,
            // 上传接口地址
            uploadAction: process.env.VUE_APP_BASE_API + '/system/upload',
            // 是否编辑个人信息
            isEditProfile: false,
            // 课程标签切换
            courseTab: 'paid',
            // 分页参数
            coursePage: 1,
            coursePageSize: 10,
            courseTotal: 0,
            // 钱包弹窗控制
            showRechargeDialog: false,
            showWithdrawDialog: false,
            // 提现表单
            withdrawForm: {
                amount: '',
                account: '',
                name: ''
            },
            // 课程发布弹窗
            showPublishCourseDialog: false,
            coursePublishTip: '',
            // 修改密码弹窗
            showPasswordDialog: false,
            // 修改密码表单
            passwordForm: {
                code: '',
                newPassword: '',
                confirmPassword: ''
            },
            // 密码表单验证规则
            passwordRules: {
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不少于6位', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请确认新密码', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        if (value !== this.passwordForm.newPassword) {
                            callback(new Error('两次密码输入不一致'))
                        } else {
                            callback()
                        }
                    }, trigger: 'blur' }
                ]
            },
            // 验证码倒计时
            codeCountdown: 0,
            
            // 侧边导航列表（新增钱包/教师入驻）
            navList: [
                { key: 'profile', name: '个人信息', icon: 'el-icon-user' },
                { key: 'courses', name: '我的课程', icon: 'el-icon-folder-opened' },
                { key: 'wallet', name: '我的钱包', icon: 'el-icon-wallet' },
                { key: 'teacher', name: '教师中心', icon: 'el-icon-trophy' },
                { key: 'security', name: '账户安全', icon: 'el-icon-lock' }
            ],

            // 用户基本信息
            userInfo: {
                avatar: '',
                nickname: '',
                username: ''
            },

            // 个人信息表单
            userForm: {
                username: '',
                nickname: '',
                mobile: '',
                email: '',
                gender: '',
                birthday: '',
                motto: ''
            },

            lastLoginTime: '',

            // 我的课程列表
            courseList: [],

            // 账户安全列表
            securityList: [
                { icon: 'el-icon-key', title: '登录密码', desc: '上次登录：', btnText: '修改密码', handleClick: () => this.modifyPwd() },
            ],

            // 钱包信息
            walletInfo: {
                balance: 0, // 账户余额
                freezeBalance: 0 // 申请中金额
            },

            // 账单类型
            billType: 0,
            // 账单列表
            billList: [],
            // 账单分页
            billPage: 1,
            billPageSize: 10,
            billTotal: 0,

            
            // 教师入驻状态： none(未入驻)/auditing(审核中)/reject(驳回)/passed(通过)
            teacherStatus: '',
            // 教师入驻表单
            teacherApplyForm: {
                realName: '',
                phone: '',
                idCard: '',
                subject: [],
                motto: '',
                certificate: []
            },
            // 教师入驻表单验证规则
            teacherFormRules: {
                realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }],
                idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }, { pattern: /^\d{17}[\dXx]$/, message: '身份证号格式错误', trigger: 'blur' }],
                subject: [{ required: true, message: '请选择教学方向', trigger: 'change' }],
                motto: [{ required: true, message: '请输入个人简介', trigger: 'blur' }, { min: 50, message: '简介不少于50字', trigger: 'blur' }],
                certificate: [{ required: true, message: '请上传至少一张资质证明', trigger: 'change' }]
            },
            // 资质证明文件列表
            certFileList: [],

            // 教师审核信息
            teacherAuditInfo: {
                submitTime: '',
                expectTime: '',
                rejectReason: '',
                substatus: 0
            },

            // 发布课程表单
            publishCourseForm: {
                name: '',
                category: [],
                ctype: "1",
                is_free: "1",
                price: 0,
                desc: '',
                describe: '',
                cover: ''
            },
            // 课程分类选项
            categoryOptions: [],
            // 课程封面文件列表
            courseCoverFileList: [],
            // 课程资料文件列表
            courseMaterialFileList: [],

            // 已发布课程列表
            publishedCourseList: [],
            // 已发布课程分页
            publishedCourseLoading: false,
            publishedCoursePage: 1,
            publishedCoursePageSize: 10,
            publishedCourseTotal: 0,
            // 教学方向列表
            servers: [],
            // 章节管理
            showChapterDialog: false,
            showChapterFormDialog: false,
            currentCourse: null,
            chapterList: [],
            chapterPage: 1,
            chapterPageSize: 10,
            chapterTotal: 0,
            chapterForm: {
                id: null,
                title: '',
                video: '',
                duration: 0,
                file: '',
                sort: 0
            }
        };
    },
    computed: {
        // 筛选后的账单列表
        filterBillList() {
            return this.billList;
        }
    },
    mounted() {
        // 从Session中加载用户信息
        this.getConfigs();
        this.loadUserInfo();
        this.getScourceList();
        this.getWalletInfo();
        this.fetchCourseList();
    },
    methods: {
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (typeof url === 'string' && (url.startsWith('http://') || url.startsWith('https://'))) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        },
        getConfigs(){
            getConfigs({type: 'teacher_servers'}).then(res => {
                if(res.code){
                    this.servers = res.data.teacher_servers
                }
            }).catch(err => {
            })
        },
        // 加载用户信息
        loadUserInfo() {
            let that = this;
            let huserInfo = Session.get('userInfo');
            if (huserInfo) {
                // 获取个人信息
                getUserInfo().then(res => {
                    if (res.code && res.data) {
                        that.userInfo = res.data;
                        let formFields = ['username', 'nickname', 'mobile', 'email', 'gender', 'birthday', 'motto'];
                        // 初始化空的userForm
                        that.userForm = {
                            username: res.data.username || '',
                            nickname: res.data.nickname || '',
                            mobile: res.data.mobile || '',
                            email: res.data.email || '',
                            gender: res.data.gender || 0,
                            birthday: res.data.birthday || '',
                            motto: res.data.motto || ''
                        };
                        that.lastLoginTime = res.data.last_login_time
                        that.teacherStatus = res.data.teacherStatus
                        that.teacherAuditInfo = res.data.teacherAuditInfo
                    }else{
                        that.$message.error(res.msg || '获取用户信息失败！');
                        that.$router.go(-1);
                    }
                }).catch(() => {
                    that.$message.error('获取用户信息失败！');
                    that.$router.go(-1);
                });
            }else{
                // 提示未登录，返回上一页
                that.$message.error('请先登录！');
                that.$router.go(-1);
            }
        },
        // 切换导航
        switchNav(key) {
            this.activeNav = key;
            this.isEditProfile = false;
            if (key === 'courses') {
                this.coursePage = 1;
                this.getScourceList();
            } else if (key === 'wallet') {
                this.getWalletInfo();
            }else if (key === 'teacher') {
                this.publishedCoursePage = 1;
                this.fetchCourseList();
            }
        },

        // 切换编辑个人信息状态
        toggleEditProfile() {
            this.isEditProfile = !this.isEditProfile;
            // 信息会员
            if (!this.isEditProfile) {
                this.userForm = {
                    username: this.userInfo.username || '',
                    nickname: this.userInfo.nickname || '',
                    mobile: this.userInfo.mobile || '',
                    email: this.userInfo.email || '',
                    gender: this.userInfo.gender || 0,
                    birthday: this.userInfo.birthday || '',
                    motto: this.userInfo.motto || ''
                }
            }
        },
        // 保存个人信息
        saveProfile() {
            const loading = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            
            updateUserInfo(this.userForm).then(res => {
                if (res.code) {
                    this.$message.success('个人信息修改成功！')
                    this.userInfo.nickname = this.userForm.nickname
                    this.userInfo.username = this.userForm.username
                    this.userInfo.email = this.userForm.email
                    this.userInfo.gender = this.userForm.gender
                    this.userInfo.birthday = this.userForm.birthday
                    this.userInfo.motto = this.userForm.motto
                    this.isEditProfile = false
                } else {
                    this.$message.error(res.msg || '个人信息修改失败！')
                }
            }).catch(() => {
                this.$message.error('个人信息修改失败！')
            }).finally(() => {
                loading.close()
            })
        },
        // 头像加载失败处理
        handleAvatarError(e) {
            e.target.src = require('@/static/imgs/default.jpeg')
        },
        // 获取课程列表
        getScourceList() {
            let that = this;
            that.courseList = [];
            getUserCourseList({
                page: that.coursePage,
                limit: that.coursePageSize,
                type: that.courseTab
            }).then(res => {
                if (res.code && res.data) {
                    that.courseList = res.data.list || res.data;
                    that.courseTotal = res.data.total || 0;
                }
            }).catch(() => {
                that.$message.error('获取课程列表失败！');
            });
        },
        // 分页变化
        handlePageChange(page) {
            this.coursePage = page;
            this.getScourceList();
        },
        // 课程封面加载失败处理
        handleCourseCoverError(e) {
            e.target.src = require('@/static/imgs/default.jpeg');
        },
        // 移除课程
        removeCourse(id) {
            let that = this;
            that.$confirm('确定要移出该课程吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                // 调用接口移除课程
                dolCollect({ id }).then(res => {
                    if (res.code) {
                        that.getScourceList();
                        that.$message.success('课程移出成功！');
                    } else {
                        that.$message.error(res.msg || '操作失败')
                    }
                }).catch(() => {
                    that.$message.error('操作失败，请稍后重试')
                })
            }).catch(() => {});
        },

        // 复制订单号
        copyOrderNo(orderNo) {
            navigator.clipboard.writeText(orderNo).then(() => {
                this.$message.success('订单号已复制');
            }).catch(() => {
                const input = document.createElement('input');
                input.value = orderNo;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                this.$message.success('订单号已复制');
            });
        },
        // 跳转到课程详情
        goCourseDetail(id) {
            this.$router.push(`/course/${id}`);
        },

        // 申请退款
        applyRefund(course) {
            this.$confirm(`您的退款申请，须符合《会员须知》及平台有关规定，确定要申请退款吗？`, '退款确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                applyRefund({ id: course.oid }).then(res => {
                    if (res.code) {
                        this.$message.success('退款申请已提交！');
                        this.getScourceList();
                    } else {
                        this.$message.error(res.msg || '退款申请失败');
                    }
                }).catch(() => {
                    this.$message.error('退款申请失败，请稍后重试');
                });
            }).catch(() => {});
        },

        // 跳转到课程分类列表
        goCourseList() {
            this.$router.push('/category');
        },

        // 编辑头像
        editAvatar() {
            let that = this;
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/jpeg,image/png,image/jpg'
            input.onchange = (e) => {
                const file = e.target.files[0]
                if (!file) return
                
                const loading = that.$loading({
                    lock: true,
                    text: '上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                
                uploadAvatar(file, (progress) => {
                    loading.text = `上传中...${progress}%`
                }).then(res => {
                    if (res.code && res.data) {
                        return updateAvatar({ avatar: res.data.url })
                    } else {
                        throw new Error(res.msg || '上传失败')
                    }
                }).then(res => {
                    if (res.code) {
                        that.userInfo.avatar = res.data.avatar || ''
                        that.userInfo.originalAvatar = res.data.avatar || ''
                        that.$message.success('头像更新成功！')
                    } else {
                        that.$message.error(res.msg || '头像更新失败！')
                    }
                }).catch(err => {
                    that.$message.error(err.message || '头像上传失败！')
                }).finally(() => {
                    loading.close()
                })
            }
            input.click()
        },

        // 钱包
        getWalletInfo() {
            let that = this;
            getWalletInfo().then(res => {
                if (res.code && res.data) {
                    that.walletInfo.balance = res.data.balance || 0;
                    that.walletInfo.freezeBalance = res.data.freeze || 0;
                }
            }).catch(() => {
                that.$message.error('获取钱包信息失败！');
            });
            
            // 获取交易列表
            that.getTransactionList();
        },

        // 获取交易列表
        getTransactionList() {
            let that = this;
            that.billList = [];
            getTransactionList({
                page: that.billPage,
                limit: that.billPageSize,
                type: that.billType
            }).then(res => {
                if (res.code && res.data) {
                    that.billList = (res.data.list || []).map(item => ({
                        ...item,
                        typeText: item.type === 1 ? '收入' : '支出',
                        tagType: item.type === 1 ? 'success' : 'warning',
                        statusText: item.status === 'succ' ? '已完成' : (item.status === 'cancel' ? '已取消' : (item.status === 'wait' ? '处理中' : '已失效'))
                    }));
                    that.billTotal = res.data.total || 0;
                }
            });
        },

        // 账单分页变化
        handleBillPageChange(page) {
            this.billPage = page;
            this.getTransactionList();
        },

        // 打开提现弹窗
        openWithdrawDialog() {
            this.showWithdrawDialog = true;
            this.withdrawForm = { amount: '', account: '', name: '' };
        },

        // 提交提现申请
        submitWithdraw() {
            if (!this.withdrawForm.amount || this.withdrawForm.amount <= 0) {
                return this.$message.error('请输入有效的提现金额！');
            }
            if (this.withdrawForm.amount > this.walletInfo.balance) {
                return this.$message.error('余额不足！');
            }
            if (!this.withdrawForm.account) {
                return this.$message.error('请输入收款账号！');
            }
            if (!this.withdrawForm.name) {
                return this.$message.error('请输入收款人姓名！');
            }

            const loading = this.$loading({
                lock: true,
                text: '提交中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            applyWithdraw(this.withdrawForm).then(res => {
                if (res.code) {
                    this.$message.success('提现申请已提交，请耐心等待审核！');
                    this.showWithdrawDialog = false;
                    this.getWalletInfo();
                } else {
                    this.$message.error(res.msg || '提现申请失败！');
                }
            }).catch(() => {
                this.$message.error('提现申请失败！');
            }).finally(() => {
                loading.close();
            });
        },

        // 账户安全相关
        modifyPwd() {
            this.showPasswordDialog = true;
        },

        // 发送验证码
        sendVerifyCode() {
            if (this.codeCountdown > 0) return;
            if (!this.userInfo.mobile) {
                this.$message.error('请先绑定手机号！');
                return;
            }
            
            const loading = this.$loading({
                lock: true,
                text: '发送中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            
            // 调用发送验证码接口
            sendSmsCode({
                mobile: this.userInfo.mobile,
                event: 'resetpwd'
            }).then(res => {
                if (res.code) {
                    this.$message.success(`验证码已发送至 ${this.userInfo.mobile}`);
                    
                    // 开始倒计时
                    this.codeCountdown = 60;
                    const timer = setInterval(() => {
                        this.codeCountdown--;
                        if (this.codeCountdown <= 0) {
                            clearInterval(timer);
                        }
                    }, 1000);
                } else {
                    this.$message.error(res.msg || '验证码发送失败！');
                }
            }).catch(() => {
                this.$message.error('验证码发送失败！');
            }).finally(() => {
                loading.close();
            });
        },

        // 修改密码
        submitPasswordChange() {
            this.$refs.passwordForm.validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '修改中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    
                    updatePassword({
                        captcha: this.passwordForm.code,
                        newpassword: this.passwordForm.newPassword,
                        mobile: this.userInfo.mobile
                    }).then(res => {
                        if (res.code) {
                            this.$message.success('密码修改成功，下次登录时生效！')
                            this.showPasswordDialog = false
                            this.resetPasswordForm()
                        } else {
                            this.$message.error(res.msg || '密码修改失败！')
                        }
                    }).catch(() => {
                        this.$message.error('密码修改失败！')
                    }).finally(() => {
                        loading.close()
                    })
                }
            })
        },

        // 重置密码表单
        resetPasswordForm() {
            this.passwordForm = {
                code: '',
                newPassword: '',
                confirmPassword: ''
            }
            this.$refs.passwordForm && this.$refs.passwordForm.resetFields()
        },

        // 提交教师入驻申请
        submitTeacherApply() {
            let that = this;
            that.$refs.teacherForm.validate((valid) => {
                if (valid) {
                    // 接口提交
                    teacherApply(that.teacherApplyForm).then(res => {
                        if (res.code) {
                            that.$message.success('教师入驻申请已提交，请耐心等待审核！');
                            that.teacherStatus = 'auditing';
                            that.showTeacherDialog = false;
                            that.resetTeacherForm();
                        } else {
                            that.$message.error(res.msg || '申请失败！');
                        }
                    }).catch(() => {
                        that.$message.error('申请失败，请稍后重试！');
                    });
                }
            });
        },

        // 重置教师入驻表单
        resetTeacherForm() {
            this.$refs.teacherForm.resetFields();
            this.certFileList = [];
        },

        // 资质证明上传
        uploadCertificateFile(options) {
            const loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            
            uploadCertificate(options.file, (progress) => {
                loading.text = `上传中...${progress}%`
            }).then(res => {
                if (res.code && res.data) {
                    this.teacherApplyForm.certificate.push(res.data.url)
                    options.onSuccess(res, options.file)
                    this.$message.success('上传成功！')
                } else {
                    options.onError(new Error(res.msg || '上传失败'))
                    this.$message.error(res.msg || '上传失败！')
                }
            }).catch(err => {
                options.onError(err)
                this.$message.error(err.message || '上传失败！')
            }).finally(() => {
                loading.close()
            })
        },

        // 资质证明上传成功
        handleCertUploadSuccess(response) {
            if (response.code && response.data) {
                this.teacherApplyForm.certificate.push(response.data.url)
            }
        },

        // 检查审核状态
        checkAuditStatus() {
            getUserInfo().then(res => {
                if (res.code) {
                    this.teacherStatus = res.data.teacherStatus
                    this.$message.success("刷新成功")
                }
            })
        },

        // 重新提交教师入驻申请
        reSubmitTeacherApply() {
            this.teacherStatus = 'none';
            this.resetTeacherForm();
            this.$message.info('请修改信息后重新提交');
        },

        // 编辑课程封面
        editCourseCover() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/jpg';
            input.onchange = (e) => {
                const file = e.target.files[0];
                if (!file) return;
                
                const loading = this.$loading({
                    lock: true,
                    text: '上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                uploadAvatar(file, (progress) => {
                    loading.text = `上传中...${progress}%`;
                }).then(res => {
                    if (res.code && res.data) {
                        this.publishCourseForm.cover = res.data.url;
                        this.$message.success('封面上传成功！');
                    } else {
                        throw new Error(res.msg || '上传失败');
                    }
                }).catch(err => {
                    this.$message.error(err.message || '封面上传失败！');
                }).finally(() => {
                    loading.close();
                });
            };
            input.click();
        },

        // 课程封面上传成功
        handleCoverUploadSuccess(response) {
            if (response.code && response.data) {
                this.publishCourseForm.cover = response.data.url
            }
        },

        // 发布课程
        publishCourse() {
            let that = this;
            if (!that.publishCourseForm.name) return that.$message.error('请输入课程标题');
            if (!that.publishCourseForm.category) return that.$message.error('请选择课程分类');
            if (that.publishCourseForm.is_free == 2 && (!that.publishCourseForm.price || that.publishCourseForm.price <= 0)) {
                return that.$message.error('请输入有效的课程价格');
            }
            if (!that.publishCourseForm.cover) return that.$message.error('请上传课程封面');

            // 发布
            publishCourse(that.publishCourseForm).then(res => {
                if (res.code) {
                    that.$message.success('课程发布成功！');
                    // 重置表单
                    that.showPublishCourseDialog = false;
                    that.resetPublishCourseForm();
                    // 获取课程列表
                    that.publishedCoursePage = 1;
                    that.fetchCourseList();
                } else {
                    that.$message.error(res.msg || '课程发布失败！');
                }
            }).catch(err => {
                that.$message.error(err.msg || '课程发布失败！');
            });
        },

        // 重置发布课程
        resetPublishCourseForm() {
            this.publishCourseForm = {
                name: '',
                category: [],
                ctype: "1",
                is_free: "1",
                price: 0,
                desc: '',
                describe: '',
                cover: ''
            };
        },

        // 打开发布课程弹窗
        openPublishDialog() {
            this.resetPublishCourseForm();
            this.showPublishCourseDialog = true;
            this.getCategoryList();
            if (!this.coursePublishTip) {
                getCoursePublishTip().then(res => {
                    if (res.code) this.coursePublishTip = res.data.content;
                });
            }
        },

        // 获取课程分类
        getCategoryList() {
            let that = this;
            getCategory().then(res=>{
                if(res.code){
                    that.categoryOptions = res.data
                }
            }).catch((err) => { 
                that.$message.error('获取分类列表失败');
            })
        },

        // 获取课程列表
        fetchCourseList() {
            let that = this;
            that.publishedCourseList = [];
            that.publishedCourseLoading = true;
            getMyCourseList({
                page: that.publishedCoursePage,
                limit: that.publishedCoursePageSize
            }).then(res => {
                that.publishedCourseLoading = false;
                if (res.code && res.data) {
                    that.publishedCourseList = res.data.list || [];
                    that.publishedCourseTotal = res.data.total || 0;
                }
            }).catch(() => {
                that.publishedCourseLoading = false;
                that.$message.error('获取课程列表失败！');
            });
        },

        // 已发布课程分页变化
        handlePublishedPageChange(page) {
            this.publishedCoursePage = page;
            this.fetchCourseList();
        },

        // 编辑课程
        editCourse(course) {
            if (course.is_sh == 1) {
                return this.$message.warning('课程已审核通过，无法编辑！');
            }
            this.publishCourseForm = {
                id: course.id,
                name: course.name,
                category: course.cid ? [course.parent_id, course.cid] : [],
                ctype: course.ctype + '',
                is_free: course.is_free + '',
                price: course.price,
                desc: course.desc,
                describe: course.describe,
                cover: course.cover
            };
            this.showPublishCourseDialog = true;
            this.getCategoryList();
            if (!this.coursePublishTip) {
                getCoursePublishTip().then(res => {
                    if (res.code) this.coursePublishTip = res.data.content;
                });
            }
        },

        // 删除课程
        deleteCourse(course) {
            if (course.status == 1) {
                return this.$message.warning('课程已审核通过，无法删除！');
            }
            this.$confirm('确定要删除该课程吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                deleteCourse({ id: course.id }).then(res => {
                    if (res.code) {
                        this.$message.success('课程删除成功！');
                        this.fetchCourseList();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                }).catch(() => {
                    this.$message.error('删除失败，请稍后重试');
                });
            }).catch((err) => {});
        },

        // 章节管理
        manageChapter(course) {
            this.getChapterList(course.id);
            this.currentCourse = course;
            this.chapterPage = 1;
            this.showChapterDialog = true;
        },

        // 关闭章节管理
        resetChapterForm(){
            // 更新
            this.fetchCourseList();
        },

        // 获取章节列表
        getChapterList(courseId) {
            this.chapterList = [];
            getChapterList({ 
                id: courseId,
                page: this.chapterPage,
                limit: this.chapterPageSize
            }).then(res => {
                if (res.code && res.data) {
                    this.chapterList = res.data.list || res.data;
                    this.chapterTotal = res.data.total || 0;
                }
            }).catch(() => {
                this.$message.error('获取章节列表失败');
            });
        },

        // 章节分页变化
        handleChapterPageChange(page) {
            this.chapterPage = page;
            this.getChapterList(this.currentCourse.id);
        },

        // 添加章节
        addChapter() {
            this.chapterForm = { id: null, title: '', video: '', duration: 0, file: '', sort: 0 };
            this.showChapterFormDialog = true;
        },

        // 编辑章节
        editChapter(chapter) {
            this.chapterForm = { ...chapter };
            this.showChapterFormDialog = true;
        },

        // 上传章节视频
        uploadChapterVideo() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'video/*, .mp3, .mp4, .avi, .wmv, .mkv, .mov, .flv, .rmvb, .3gp, .ogg, .webm';
            input.onchange = (e) => {
                const file = e.target.files[0];
                if (!file) return;
                
                const loading = this.$loading({
                    lock: true,
                    text: '上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                uploadCourseMaterial(file, (progress) => {
                    loading.text = `上传中...${progress}%`;
                }).then(res => {
                    if (res.code && res.data) {
                        this.chapterForm.video = res.data.url;
                        this.$message.success('视频上传成功！');
                    } else {
                        throw new Error(res.msg || '上传失败');
                    }
                }).catch(err => {
                    this.$message.error(err.message || '视频上传失败！');
                }).finally(() => {
                    loading.close();
                });
            };
            input.click();
        },

        // 上传章节文件
        uploadChapterFile() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip,.rar,.png,.jpg,.jpeg,.gif,.bmp,.txt,.md,.xml,.json,.sql,.exe,.dll,.bat,.psd,.ai,.eps,.psd,.cdr,.sketch,.fig,.svg,.eps,.psd,.cdr,.sketch,.fig,.svg,.eps,.psd,.cdr,.sketch,.fig,.svg,.eps,.psd,.cdr,.sketch,.fig,.svg';
            input.onchange = (e) => {
                const file = e.target.files[0];
                if (!file) return;
                
                const loading = this.$loading({
                    lock: true,
                    text: '上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                uploadCourseMaterial(file, (progress) => {
                    loading.text = `上传中...${progress}%`;
                }).then(res => {
                    if (res.code && res.data) {
                        this.chapterForm.file = res.data.url;
                        this.$message.success('文件上传成功！');
                    } else {
                        throw new Error(res.msg || '上传失败');
                    }
                }).catch(err => {
                    this.$message.error(err.message || '文件上传失败！');
                }).finally(() => {
                    loading.close();
                });
            };
            input.click();
        },

        // 保存章节
        saveChapter() {
            if (!this.chapterForm.title) {
                return this.$message.error('请输入章节标题');
            }
            if (this.currentCourse && this.currentCourse.ctype == 1 && !this.chapterForm.video) {
                return this.$message.error('请上传视频');
            }
            if (this.currentCourse && this.currentCourse.ctype == 2 && !this.chapterForm.file) {
                return this.$message.error('请上传文件');
            }
            
            const data = {
                ...this.chapterForm,
                course_id: this.currentCourse.id
            };
            publishCourseChapter(data).then(res => {
                if (res.code) {
                    this.$message.success('保存成功');
                    this.showChapterFormDialog = false;
                    this.getChapterList(this.currentCourse.id);
                } else {
                    this.$message.error(res.msg || '保存失败');
                }
            }).catch(() => {
                this.$message.error('保存失败');
            });
        },

        // 删除章节
        deleteChapter(chapter) {
            this.$confirm('确定要删除该章节吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                deleteCourseChapter({ id: chapter.id }).then(res => {
                    if (res.code) {
                        this.$message.success('删除成功');
                        this.getChapterList(this.currentCourse.id);
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                }).catch(() => {
                    this.$message.error('删除失败');
                });
            }).catch(() => {});
        }
    }
}
</script>

<style scoped>
/* 基础布局修复：核心解决布局错乱问题 */
.user-center-page {
    min-height: 100vh;
    background-color: #f5f7fa;
    font-size: 14px;
}
.container {
    width: 100%;
    max-width: 1400px; /* 适配大屏，避免过宽 */
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

/* 主体布局：Flex + 溢出处理 */
.user-center-main {
    padding: 30px 0;
    display: flex;
    flex-wrap: nowrap; /* 禁止换行，避免布局错乱 */
}
.sidebar {
    width: 280px;
    flex-shrink: 0; /* 禁止侧边栏收缩 */
    margin-right: 24px;
}
.main-content {
    flex: 1;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    min-height: 800px; /* 最小高度，避免内容过少时布局塌陷 */
}

/* 侧边栏 - 个人信息卡片 */
.user-info-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    text-align: center;
}
.avatar-wrap {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0 auto 16px;
}
.user-avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid #f5f7fa;
}
.avatar-mask {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 28px;
    height: 28px;
    background: #1890ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s ease;
}
.avatar-wrap:hover .avatar-mask {
    opacity: 1;
}
.user-base-info {
    margin-bottom: 16px;
}
.username {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}
.user-role {
    font-size: 14px;
    padding: 2px 8px;
    border-radius: 12px;
    display: inline-block;
    margin-bottom: 8px;
}
.teacher-role {
    background: #e6f7ff;
    color: #1890ff;
}
.student-role {
    background: #f0fff4;
    color: #52c41a;
}
.user-level {
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.user-stats {
    display: flex;
    justify-content: space-around;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
    margin-top: 16px;
}
.stats-item {
    text-align: center;
}
.stats-num {
    font-size: 18px;
    font-weight: 600;
    color: #1890ff;
    display: block;
}
.stats-text {
    font-size: 12px;
    color: #999;
}

/* 侧边导航 */
.sidebar-nav {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.nav-item {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    transition: all 0.3s ease;
    border-left: 3px solid transparent;
}
.nav-item.active {
    background: #e6f7ff;
    color: #1890ff;
    border-left-color: #1890ff;
}
.nav-item:hover:not(.active) {
    background: #f5f7fa;
    color: #1890ff;
}

/* 主内容面板通用样式 */
.content-panel {
    padding: 30px;
    box-sizing: border-box;
    width: 100%;
}
.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
}
.panel-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
}
.panel-title i {
    color: #1890ff;
    font-size: 22px;
}
.apply-tip {
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 4px;
}

/* 个人信息表单 */
.profile-form {
    background: #f9f9f9;
    padding: 24px;
    border-radius: 8px;
}

/* 我的课程列表 */
.course-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.course-item {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    transition: all 0.3s ease;
}
.course-item:hover {
    border-color: #1890ff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
}
.course-cover {
    width: 120px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 16px;
    position: relative;
    flex-shrink: 0; /* 禁止封面收缩 */
}
.course-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.learn-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 4px 8px;
    font-size: 12px;
}
.learn-progress .progress-bar {
    height: 2px;
    background: #333;
    border-radius: 1px;
    margin-top: 4px;
    overflow: hidden;
}
.progress-fill {
    height: 100%;
    background: #1890ff;
}
.course-info {
    flex: 1;
    margin-right: 16px;
}
.course-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
    cursor: pointer;
    transition: color 0.3s ease;
}
.course-title:hover {
    color: #1890ff;
}
.course-teacher {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
}
.course-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.meta-item {
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
}
.free-tag {
    background: #f0fff4;
    color: #00bfa5;
}
.pay-tag {
    background: #fff7e6;
    color: #ff9500;
}
.order-no-item {
    background: #f0f0f0;
    color: #555;
    cursor: default;
}
.copy-icon {
    cursor: pointer;
    color: #1890ff;
    margin-left: 4px;
}
.copy-icon:hover {
    color: #096dd9;
}
.course-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0; /* 禁止按钮区收缩 */
}

/* 空状态 */
.empty-state {
    text-align: center;
    padding: 80px 0;
    color: #94a3b8;
}
.empty-state i {
    font-size: 64px;
    margin-bottom: 16px;
    color: #cbd5e1;
}
.empty-state p {
    font-size: 18px;
    margin-bottom: 24px;
}

/* 学习数据统计卡片 */
.stats-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); /* 响应式网格 */
    gap: 20px;
    margin-bottom: 24px;
}
.stats-card {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 24px;
    margin-right: 16px;
}
.bg-blue { background: linear-gradient(135deg, #1890ff, #40a9ff); }
.bg-green { background: linear-gradient(135deg, #52c41a, #73d13d); }
.bg-orange { background: linear-gradient(135deg, #fa8c16, #ffa940); }
.bg-purple { background: linear-gradient(135deg, #722ed1, #9254de); }
.card-content { flex: 1; }
.card-desc { font-size: 14px; color: #666; margin-bottom: 4px; }
.card-num { font-size: 24px; font-weight: 600; color: #333; margin-bottom: 4px; }
.card-trend { font-size: 12px; display: flex; align-items: center; gap: 4px; }
.text-green { color: #52c41a; }
.text-red { color: #ff4d4f; }

/* 图表区域 */
.chart-wrap {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.chart-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 16px;
}

/* 账户安全列表 */
.security-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.security-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    transition: all 0.3s ease;
}
.security-item:hover {
    border-color: #1890ff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
}
.item-left {
    display: flex;
    align-items: center;
    gap: 12px;
}
.item-left i {
    font-size: 24px;
    color: #1890ff;
}
.item-info h4 {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
}
.item-info p {
    font-size: 14px;
    color: #666;
}

/* 钱包模块样式 */
.wallet-balance-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 16px;
    padding: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}
.balance-info {
    flex: 1;
    display: flex;
    gap: 48px;
}
.balance-item {
    flex: 1;
}
.freeze-item {
    border-left: 2px solid rgba(255, 255, 255, 0.3);
    padding-left: 48px;
}
.balance-label {
    font-size: 14px;
    opacity: 0.9;
    margin-bottom: 12px;
}
.balance-amount {
    font-size: 42px;
    font-weight: 700;
    margin: 0;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.freeze-amount {
    font-size: 28px;
    font-weight: 600;
    margin: 0;
    opacity: 0.95;
}
.balance-actions {
    display: flex;
    gap: 12px;
    flex-shrink: 0;
}
.balance-actions .el-button {
    padding: 12px 24px;
    font-size: 15px;
    border-radius: 8px;
    font-weight: 500;
}
.bill-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.bill-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}
.recharge-amounts {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}
.amount-item {
    width: 80px;
    height: 40px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}
/* 充值金额选项激活态补全 */
.amount-item.active {
    border-color: #1890ff;
    background: #e6f7ff;
    color: #1890ff;
}
.amount-item:hover:not(.active) {
    border-color: #1890ff;
}

/* 提现提示文本 */
.withdraw-tip {
    font-size: 12px;
    color: #666;
    margin-top: 8px;
}

/* 教师入驻 - 审核中样式 */
.teacher-audit-ing, .teacher-audit-reject {
    padding: 40px 20px;
    text-align: center;
}
.audit-card, .reject-card {
    max-width: 600px;
    margin: 0 auto;
    background: #fff;
    border-radius: 12px;
    padding: 40px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.audit-icon {
    font-size: 64px;
    color: #1890ff;
    margin-bottom: 24px;
}
.audit-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
}
.audit-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 24px;
}
.audit-info {
    text-align: left;
    padding: 16px;
    background: #f5f7fa;
    border-radius: 8px;
    margin-bottom: 24px;
    font-size: 14px;
    color: #666;
}
.audit-info p {
    margin-bottom: 8px;
}
.audit-info p:last-child {
    margin-bottom: 0;
}

/* 教师入驻 - 审核驳回样式 */
.reject-icon {
    font-size: 64px;
    color: #ff4d4f;
    margin-bottom: 24px;
}
.reject-title {
    font-size: 20px;
    font-weight: 600;
    color: #ff4d4f;
    margin-bottom: 16px;
}
.reject-reason {
    text-align: left;
    padding: 16px;
    background: #fff2f0;
    border-radius: 8px;
    margin-bottom: 24px;
    border: 1px solid #ffccc7;
}
.reason-label {
    font-size: 14px;
    font-weight: 500;
    color: #ff4d4f;
    margin-bottom: 8px;
}
.reason-content {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
}

/* 教师中心 - 已发布课程卡片 */
.published-course-list .list-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
}
.course-card-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
}
.course-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}
.course-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.course-card .card-header {
    position: relative;
    height: 160px;
}
.course-card .course-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.course-card .course-tag {
    position: absolute;
    top: 12px;
    right: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
}
.course-card .card-body {
    padding: 16px;
}
.course-card .course-status {
    margin-bottom: 8px;
}
.course-card .course-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.course-card .course-meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #666;
}
.course-card .card-actions {
    padding: 0 16px 16px;
    display: flex;
    gap: 8px;
}

/* 章节管理样式 */
.chapter-header {
    display: flex;
    justify-content: flex-end;
}
.video-upload-wrap,
.file-upload-wrap {
    width: 100%;
    height: 100px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}
.video-upload-wrap:hover,
.file-upload-wrap:hover {
    border-color: #1890ff;
}
.video-info,
.file-info {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #52c41a;
}
.video-info i,
.file-info i {
    font-size: 24px;
}
.upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #8c939d;
}
.upload-placeholder i {
    font-size: 32px;
    margin-bottom: 8px;
}
.upload-placeholder p {
    font-size: 14px;
    margin: 0;
}

/* 课程封面上传样式 */
.cover-upload-wrap {
    width: 148px;
    height: 148px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
}
.cover-upload-wrap:hover {
    border-color: #1890ff;
}
.cover-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.cover-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8c939d;
}
.cover-placeholder i {
    font-size: 28px;
    margin-bottom: 8px;
}
.cover-placeholder p {
    font-size: 12px;
    margin: 0;
}

/* 文本颜色辅助类 */
.text-green {
    color: #52c41a;
}
.text-red {
    color: #ff4d4f;
}
.publish-tip {
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 20px;
    font-size: 13px;
    color: #614700;
    line-height: 1.8;
}

/* 响应式适配 - 小屏幕布局调整 */
@media (max-width: 80%) {
    .container {
        max-width: 1000px;
    }
    .stats-cards {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
}

@media (max-width: 992px) {
    .user-center-main {
        flex-direction: column;
    }
    .sidebar {
        width: 100%;
        margin-right: 0;
        margin-bottom: 24px;
    }
    .sidebar-nav {
        display: flex;
        overflow-x: auto;
        border-radius: 8px;
    }
    .nav-item {
        flex: 0 0 auto;
        border-left: none;
        border-bottom: 3px solid transparent;
        padding: 12px 16px;
    }
    .nav-item.active {
        border-left: none;
        border-bottom-color: #1890ff;
    }
    .course-card-list {
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    }
}

@media (max-width: 768px) {
    .content-panel {
        padding: 20px 16px;
    }
    .panel-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
    .wallet-balance-card {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
    .balance-actions {
        width: 100%;
        justify-content: flex-start;
    }
    .course-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }
    .course-cover {
        width: 100%;
        height: auto;
        margin-right: 0;
    }
    .course-info {
        margin-right: 0;
        width: 100%;
    }
    .course-actions {
        width: 100%;
        justify-content: flex-start;
    }
    .stats-cards {
        grid-template-columns: 1fr;
    }
    .course-card-list {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 480px) {
    .user-stats {
        flex-direction: column;
        gap: 12px;
    }
    .recharge-amounts {
        gap: 8px;
    }
    .amount-item {
        width: calc(50% - 4px);
    }
    .audit-card, .reject-card {
        padding: 24px 16px;
    }
}
</style>